import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import SignInSecurity from '../components/signin-security-view';
import {
  socialAccountsData,
  socialAccountsByUserIdGet,
  socialSignInLinks,
  socialSignInLinksGet,
} from 'modules/social-module';
import {
  meId,
  meData,
  meEntitlements,
  meIsOrganizationMember,
  meIsOrganizationAdmin,
  meSocialLoginEnabled,
  meForceSamlSsoLoginRequestGet,
  meForceSamlSsoLogin,
} from 'modules/me-module';
import {
  organizationKey,
  orgServiceDomainsRequestGet,
} from 'modules/organization-module';
import {
  enrolledInTfa,
  tfaMeRequestGet,
} from 'modules/tfa-module';
import environment from 'lib/environment';
import appconfig from 'config/appconfig';
import Session from 'lib/session';
import { getQueryStringParams } from 'lib/utility-functions';

const oauthClientId = environment.get().oauth.client_id;

export class SignInSecurityContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      openDevicesDialogOnLoad: false,
    };
  }

  componentDidMount() {
    if (this.props.isOrganizationMember) {
      this.props.orgServiceDomainsRequestGet(this.props.orgKey);
    }
    this.props.socialAccountsByUserIdGet(this.props.userId);
    this.props.forceSamlSsoLoginRequestGet(this.props.personData.userName);

    if (!Session.getItem('devicesDialog')) {
      const queryValues = getQueryStringParams(this.props.location.search);
      if (queryValues.devices) {
        Session.setItem('devicesDialog', 'true');
        this.setState({openDevicesDialogOnLoad: true});
      }
    }

    const params = {
      redirectUrl: encodeURIComponent(location.href.split('#')[0]),
      clientId: oauthClientId,
    };
    this.props.socialSignInLinksGet(params);
    this.props.tfaMeRequestGet();
  }

  enterpriseSignInEnabled = () => {
    let showEnterpriseSignIn = false;
    const emailParts = this.props.personData.userName.split('@');
    if (appconfig.blackListedDomains.indexOf(emailParts[1].split('.')[0].toLowerCase()) === -1) {
      showEnterpriseSignIn = true;
    }
    if (this.props.isOrganizationMember && !this.props.isOrganizationAdmin) {
      showEnterpriseSignIn = false;
    }
    return showEnterpriseSignIn;
  };

  render() {
    return (
      <SignInSecurity
        isOrganizationMember={this.props.isOrganizationMember}
        isOrganizationAdmin={this.props.isOrganizationAdmin}
        socialLoginEnabled={this.props.socialLoginEnabled && !this.props.forceSamlSsoLogin}
        socialAccounts={this.props.socialAccounts}
        socialSignInLinks={this.props.socialSignInLinks}
        enrolledInTFAProducts={this.props.enrolledInTFAProducts}
        enterpriseSignInEnabled={this.enterpriseSignInEnabled()}
        forceSamlSsoLogin={this.props.forceSamlSsoLogin}
        openDevicesDialogOnLoad={this.state.openDevicesDialogOnLoad}
      />
    );
  }
}

SignInSecurityContainer.propTypes = {
  personData: PropTypes.object.isRequired,
  orgKey: PropTypes.string.isRequired,
  orgServiceDomainsRequestGet: PropTypes.func.isRequired,
  isOrganizationMember: PropTypes.bool.isRequired,
  isOrganizationAdmin: PropTypes.bool.isRequired,
  socialLoginEnabled: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
  enrolledInTFAProducts: PropTypes.array.isRequired,
  socialAccountsByUserIdGet: PropTypes.func.isRequired,
  socialAccounts: PropTypes.array.isRequired,
  socialSignInLinksGet: PropTypes.func.isRequired,
  socialSignInLinks: PropTypes.object.isRequired,
  tfaMeRequestGet: PropTypes.func.isRequired,
  forceSamlSsoLoginRequestGet: PropTypes.func.isRequired,
  forceSamlSsoLogin: PropTypes.bool.isRequired,
  location: PropTypes.object,
};

export const mapStateToProps = (state) => {
  let enrolledInTFAProducts = [];
  const entitlements = meEntitlements(state);
  // Only populate the enrolledInTFAProducts array if the user is enrolled in TFA
  if (entitlements && enrolledInTfa(state)) {
    enrolledInTFAProducts = entitlements.filter(app => appconfig.tfaSupportList.includes(app));
  }

  return {
    userId: meId(state),
    personData: meData(state),
    socialLoginEnabled: meSocialLoginEnabled(state),
    socialAccounts: socialAccountsData(state),
    orgKey: organizationKey(state),
    isOrganizationMember: meIsOrganizationMember(state),
    isOrganizationAdmin: meIsOrganizationAdmin(state),
    socialSignInLinks: socialSignInLinks(state) || {},
    forceSamlSsoLogin: meForceSamlSsoLogin(state),
    enrolledInTFAProducts,
  };
};

export const mapDispatchToProps = (dispatch) => ({
  orgServiceDomainsRequestGet: (orgKey) => dispatch(orgServiceDomainsRequestGet(orgKey)),
  socialAccountsByUserIdGet: (userId) => dispatch(socialAccountsByUserIdGet(userId)),
  socialSignInLinksGet: (params) => dispatch(socialSignInLinksGet(params)),
  tfaMeRequestGet: () => dispatch(tfaMeRequestGet()),
  forceSamlSsoLoginRequestGet: (email) => dispatch(meForceSamlSsoLoginRequestGet(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignInSecurityContainer);
